import React from 'react'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'
import PropTypes from 'prop-types'
import auth from '../../auth'
import * as api from 'api'
import { getHistory } from 'libs/history'
import { toast } from 'libs/toast'

import CreateNewPasswordPresentation from '../../components/ResetPassword/CreateNewPassword'
import getQueryStringValue from '../../libs/get-query-string-value'
import {
  isSequenceNumber,
  isRepeated,
  isValidPasswordLength,
  isValidPasswordPattern,
  getInValidMessage,
} from '../../libs/text-validation'

class CreateNewPassword extends React.Component {
  static propTypes = {
    history: PropTypes.object,
  }

  state = {
    token: '',
    newPassword: '',
    confirmPassword: '',
    isPasswordError: false,
    errorMessage: '',
    isConPasswordError: false,
    errorConMessage: '',
    isSuccess: false,
  }

  componentDidMount() {
    try {
      const token = getQueryStringValue(window.location.search, 'token')
      this.setState({ token: token })
    } catch (error) {
      this.props.history.push('/404')
    }
  }

  onNewPasswordChange = (event) => {
    this.setState({ newPassword: event.target.value })
    this.validateNewPasswordFields(event.target.value)
  }

  onConfirmPasswordChange = (event) => {
    this.setState({ confirmPassword: event.target.value })
    this.validateConfirmNewPasswordFields(event.target.value)
  }

  validateNewPasswordFields = (Password) => {
    const isConfirmNewPasswordNotMatch = Password !== this.state.confirmPassword
    const isConfirmNewPasswordBeNull = this.state.confirmPassword.length > 0
    const isNewPasswordInValid =
      !isValidPasswordPattern(Password) ||
      !isValidPasswordLength(Password) ||
      isSequenceNumber(Password) ||
      isRepeated(Password)
    if (isNewPasswordInValid) {
      this.setState({ isPasswordError: isNewPasswordInValid })
      this.setState({
        errorMessage: getInValidMessage(Password),
      })
    } else if (isConfirmNewPasswordNotMatch && isConfirmNewPasswordBeNull) {
      this.setState({ isPasswordError: true })
      this.setState({ errorMessage: "New passwords don't match" })
    } else {
      this.setState({ isPasswordError: false })
      this.setState({ errorMessage: '' })
    }
  }

  validateConfirmNewPasswordFields = (confirmPassword) => {
    const isConfirmNewPasswordInValid = this.state.newPassword !== confirmPassword

    if (isConfirmNewPasswordInValid) {
      this.setState({ isPasswordError: isConfirmNewPasswordInValid })
      this.setState({ errorMessage: "New passwords don't match" })
    }

    const inValidPasswordMessage = getInValidMessage(this.state.newPassword)
    if (inValidPasswordMessage != '') {
      this.setState({ isPasswordError: true })
      this.setState({ errorMessage: inValidPasswordMessage })
    } else if (!isConfirmNewPasswordInValid) {
      this.setState({ isPasswordError: false })
      this.setState({ errorMessage: '' })
    }
  }

  onSubmit = async (event) => {
    event.preventDefault()
    this.validateNewPasswordFields(this.state.newPassword)
    this.validateConfirmNewPasswordFields(this.state.confirmPassword)

    if (!this.state.isPasswordError) {
      api
        .postResetPasswordConfirm({
          password: this.state.newPassword,
          encoded_token: this.state.token,
        })
        .then((res) => {
          if (res.status != 200) {
            res.text().then((data) => {
              if (data) {
                toast.error(JSON.parse(data))
              } else {
                toast.error('Oops! Something went wrong. Please try again.')
              }
            })
          } else {
            toast.success('Successfully changed password.')
            auth.logout()
            getHistory().replace('/login')
          }
        })
    }
  }

  render() {
    return (
      <Page>
        <Title title="Create a new password" />
        <CreateNewPasswordPresentation
          isPasswordError={this.state.isPasswordError}
          errorMessage={this.state.errorMessage}
          newPassword={this.state.newPassword}
          confirmPassword={this.state.confirmPassword}
          onNewPasswordChange={this.onNewPasswordChange}
          onConfirmPasswordChange={this.onConfirmPasswordChange}
          onSubmit={this.onSubmit}
        />
      </Page>
    )
  }
}

export default CreateNewPassword



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/ResetPassword/CreateNewPassword.js